// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"afdf88cc","156":"35e66289","617":"510a0a3a","640":"780db19c"}[chunkId] + ".chunk.js";
};